/**
 * GitHub -> Lovable rollout safety.
 *
 * These actions require PostgreSQL migrations in the Lovable-managed backend.
 * GitHub CI tests a SEPARATE database; a successful CI run cannot establish
 * that production functions/notification keys are installed.
 *
 * OFF by default. These are PUBLIC build-time flags, not passwords or access
 * controls. Database RLS, SECURITY DEFINER guards and user confirmations still
 * enforce security when the capabilities are enabled.
 *
 * Enable only after the Lovable database migrations have been applied and
 * two-user QA completed. This makes a GitHub merge safe without assuming a
 * live database connection or consuming Lovable credits.
 */
export const SMART_NOTIFICATION_REVIEW_ENABLED =
  import.meta.env.VITE_ENABLE_SMART_NOTIFICATION_REVIEW === "true";

export const PRIVATE_OPPONENT_MERGE_ENABLED =
  SMART_NOTIFICATION_REVIEW_ENABLED &&
  import.meta.env.VITE_ENABLE_PRIVATE_OPPONENT_MERGE === "true";

export const PRIVATE_CLUB_MEMBERSHIP_MERGE_ENABLED =
  SMART_NOTIFICATION_REVIEW_ENABLED &&
  import.meta.env.VITE_ENABLE_PRIVATE_CLUB_MEMBERSHIP_MERGE === "true";


/** Enable after Club Elo migrations and two-account QA in the hosted backend. */
export const CLUB_ELO_ENABLED = import.meta.env.VITE_ENABLE_CLUB_ELO === "true";
